export default "__VITE_ASSET__owGiAl8a__"